const components = {
    textbox: {
        files: [
            { type: "js", path: "/components/textbox/ctrl-textbox.js" },
            { type: "html", path: "/components/textbox/ctrl-textbox.html" },
            { type: "css", path: "/components/textbox/ctrl-textbox.css" }
        ],
        icon: "mdi-textbox",
        componentName: "ctrl-textbox",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: [
            "guid", "data", "properties", "isMandatory", "mandatory", "readOnly", "map", "path"
        ],
        dataModel: {
            types: ["string", "integer", "decimal"]
        },
        attributes: [
            "label", "icon", "iconColor", "helper", "prefix", "suffix", "clearable", "align", "format", "tHelper", "tHelperState"
        ],
        events: [
            "onInit", "onChange", "onBlur", "onSave", "onSubmit"
        ],
        defaults: {
            label: "New textbox",
            align: "left",
            format: { type: "", decimal: ".", thousands: "," },
            tHelper: false,
            tHelperState: false
        }
    },
    upload: {
        files: [
            { type: "js", path: "/components/upload/ctrl-upload.js" },
            { type: "html", path: "/components/upload/ctrl-upload.html" },
            { type: "css", path: "/components/upload/ctrl-upload.css" }
        ],
        icon: "mdi-upload",
        componentName: "ctrl-upload",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: [
            "guid", "data", "path", "properties", "isMandatory", "mandatory", "readOnly"
        ],
        dataModel: { attachment: true },
        events: [
            "onInit", "onChange", "onSave", "onSubmit"
        ],
        attributes: [
            // eslint-disable-next-line max-len
            "label", "icon", "iconColor", "helper", "canDownload", "canUpload", "canPreview", "canRemove", "logDownloads", "extensions", "restrict", "message", "hash", "hashMapping", "tHelper", "tHelperState"
        ],
        defaults: {
            label: "New upload",
            canUpload: true,
            canRemove: true,
            logDownloads: false,
            canPreview: false,
            canDownload: false,
            extensions: "",
            restrict: false,
            message: "",
            hash: false,
            tHelper: false,
            tHelperState: false
        }
    },
    slider: {
        files: [
            { type: "js", path: "/components/slider/ctrl-slider.js" },
            { type: "html", path: "/components/slider/ctrl-slider.html" },
            { type: "css", path: "/components/slider/ctrl-slider.css" }
        ],
        icon: "mdi-vector-point",
        componentName: "ctrl-slider",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: [
            "guid", "data", "properties", "isMandatory", "mandatory", "readOnly"
        ],
        dataModel: {
            types: ["decimal", "integer"]
        },
        events: [
            "onInit", "onChange", "onSave", "onSubmit"
        ],
        attributes: [
            "label", "icon", "iconColor", "helper", "min", "max", "step", "markers", "snap", "square", "showLabel", "tHelper", "tHelperState"
        ],
        defaults: {
            label: "New slider",
            min: 0,
            max: 10,
            marker: false,
            snap: false,
            square: false,
            step: 1,
            showLabel: false,
            tHelper: false,
            tHelperState: false
        }
    },
    paragraph: {
        files: [
            { type: "js", path: "/components/paragraph/ctrl-paragraph.js" },
            { type: "html", path: "/components/paragraph/ctrl-paragraph.html" },
            { type: "css", path: "/components/paragraph/ctrl-paragraph.css" }
        ],
        icon: "mdi-format-paragraph",
        componentName: "ctrl-paragraph",
        type: "form",
        acceptNodes: false,
        props: ["guid", "data", "properties"],
        attributes: ["label", "text", "maxHeight"],
        defaults: { label: "New paragraph", text: "Content" }
    },
    richText: {
        files: [
            { type: "js", path: "/components/rich-text/ctrl-rich-text.js" },
            { type: "html", path: "/components/rich-text/ctrl-rich-text.html" },
            { type: "css", path: "/components/rich-text/ctrl-rich-text.css" }
        ],
        label: "Rich text editor",
        icon: "mdi-format-size",
        componentName: "ctrl-rich-text",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: ["guid", "data", "properties", "isMandatory", "mandatory", "readOnly", "path"],
        dataModel: { types: ["richtext"] },
        attributes: ["label", "readOnly", "contentHeight", "contentOnDemand", "icon", "textColor", "color", "hasContent"],
        defaults: {
            label: "New rich text",
            readOnly: false,
            contentHeight: 500,
            contentOnDemand: false,
            hasContent: true,
            titleColor: "tertiary",
            headerColor: "accent"
        },
        fn: {
            checkMandatory(_, properties) {
                return properties.hasContent;
            }
        }
    },
    image: {
        files: [
            { type: "js", path: "/components/image/ctrl-image.js" },
            { type: "html", path: "/components/image/ctrl-image.html" },
            { type: "css", path: "/components/image/ctrl-image.css" }
        ],
        get: true,
        icon: "mdi-image",
        componentName: "ctrl-image",
        type: "standard",
        acceptNodes: false,
        props: ["guid", "test", "data", "properties"],
        dataModel: { attachment: true },
        attributes: ["link", "image", "width", "height", "align"],
        defaults: { label: "New image", width: "auto", height: "auto", align: "left" }
    },
    textarea: {
        files: [
            { type: "js", path: "/components/textarea/ctrl-textarea.js" },
            { type: "html", path: "/components/textarea/ctrl-textarea.html" },
            { type: "css", path: "/components/textarea/ctrl-textarea.css" }
        ],
        icon: "mdi-card-text-outline",
        componentName: "ctrl-textarea",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: ["data", "properties", "guid", "isMandatory", "mandatory", "readOnly", "path"],
        dataModel: { types: ["string"] },
        events: ["onInit", "onChange", "onBlur", "onSave", "onSubmit"],
        attributes: ["helper", "label", "icon", "iconColor", "rows", "max", "tHelper", "tHelperState"],
        defaults: { label: "New textarea", rows: 4, max: 100, tHelper: false, tHelperState: false }
    },
    label: {
        files: [
            { type: "js", path: "/components/label/ctrl-label.js" },
            { type: "html", path: "/components/label/ctrl-label.html" },
            { type: "css", path: "/components/label/ctrl-label.css" }
        ],
        icon: "mdi-format-letter-case",
        componentName: "ctrl-label",
        type: "form",
        get: true,
        acceptNodes: false,
        props: ["data", "properties", "guid"],
        events: ["onInit"],
        dataModel: { types: ["string"] },
        attributes: ["label", "icon", "iconColor", "linkable", "size"],
        defaults: { label: "Label", linkable: false, size: "Small" }
    },
    // The component has been temporarily removed until a more generic solution can be implemented.
    // websocket: {
    //     files: [
    //         { type: "js", path: "/components/websocket/ctrl-websocket.js" },
    //         { type: "html", path: "/components/websocket/ctrl-websocket.html" },
    //         { type: "css", path: "/components/websocket/ctrl-websocket.css" }
    //     ],
    //     icon: "mdi-power-plug",
    //     componentName: "ctrl-websocket",
    //     type: "form",
    //     set: true,
    //     acceptNodes: false,
    //     dataModel: { types: ["string"] },
    //     events: ["onConnect", "onMessage", "onDisconnect"],
    //     attributes: ["label", "icon", "iconColor", "wsUrl", "eventData"],
    //     defaults: {
    //         label: "Label",
    //         wsUrl: "/websocket/contractEvents",
    // eslint-disable-next-line max-len
    // eventData:
    // eslint-disable-next-line max-len
    // '{"networkUrl":"http://10.10.21.181:22000","contractAddress":"0x4e167dFc756D6A050aF706bf679a67B01cb3e385","eventName":"Transfer","parameters":[{"isIndexed":true,"name":"from","type":"address"},{"isIndexed":true,"name":"to","type":"address"},{"isIndexed":false,"name":"value","type":"uint256"}]}'
    //     }
    // },
    chart: {
        files: [
            { type: "js", path: "/components/chart/ctrl-chart.js" },
            { type: "html", path: "/components/chart/ctrl-chart.html" },
            { type: "css", path: "/components/chart/ctrl-chart.css" }
        ],
        icon: "mdi-poll-box",
        componentName: "ctrl-chart",
        type: "standard",
        get: true,
        acceptNodes: false,
        props: ["data", "properties", "events", "guid", "template"],
        dataModel: { types: ["string"] },
        customEvents: ["onData"],
        attributes: ["label"],
        defaults: { label: "Label" }
    },
    button: {
        files: [
            { type: "js", path: "/components/button/ctrl-button.js" },
            { type: "html", path: "/components/button/ctrl-button.html" },
            { type: "css", path: "/components/button/ctrl-button.css" }
        ],
        icon: "mdi-square-inc",
        componentName: "ctrl-button",
        type: "standard",
        acceptNodes: false,
        props: ["data", "properties", "guid", "path", "newRender"],
        localEvents: ["onClick"],
        events: ["onClick"],
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align"],
        defaults: { label: "Button", align: "left", full: false, right: false, color: "primary", textColor: "white" }
    },
    process: {
        files: [
            { type: "js", path: "/components/process/ctrl-process.js" },
            { type: "html", path: "/components/process/ctrl-process.html" },
            { type: "css", path: "/components/process/ctrl-process.css" }
        ],
        icon: "mdi-plus-box",
        label: "Initiate process",
        componentName: "ctrl-process",
        type: "standard",
        acceptNodes: false,
        props: ["data", "properties", "path", "guid"],
        events: ["onClick"],
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align", "process", "configure"],
        defaults: {
            label: "INITIATE PROCESS",
            align: "left",
            full: false,
            right: false,
            configure: {},
            color: "primary",
            textColor: "white"
        }
    },
    apibutton: {
        files: [
            { type: "js", path: "/components/api-button/ctrl-api-button.js" },
            { type: "html", path: "/components/api-button/ctrl-api-button.html" },
            { type: "css", path: "/components/api-button/ctrl-api-button.css" }
        ],
        label: "API Button",
        icon: "mdi-cloud-sync",
        componentName: "ctrl-api-button",
        type: "standard",
        acceptNodes: false,
        props: ["data", "properties", "guid"],
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align", "mapping", "mergeData"],
        defaults: {
            label: "API Button",
            align: "left",
            full: false,
            right: false,
            mergeData: false,
            mapping: {},
            color: "primary",
            textColor: "white"
        }
    },
    blockchainbutton: {
        files: [
            { type: "js", path: "/components/blockchain-button/blockchain-button.js" },
            { type: "html", path: "/components/blockchain-button/blockchain-button.html" },
            { type: "css", path: "/components/blockchain-button/blockchain-button.css" }
        ],
        label: "Smart Contract Button",
        icon: "mdi-cloud-sync",
        componentName: "blockchain-button",
        type: "standard",
        acceptNodes: false,
        props: ["data", "properties", "guid"],
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align", "mapping", "mergeData"],
        defaults: {
            label: "Smart Contract Button",
            align: "left",
            full: false,
            right: false,
            mergeData: false,
            mapping: {},
            color: "primary",
            textColor: "white"
        }
    },
    metamaskbutton: {
        files: [
            { type: "js", path: "/components/metamask-button/ctrl-metamask.js" },
            { type: "html", path: "/components/metamask-button/ctrl-metamask.html" },
            { type: "css", path: "/components/metamask-button/ctrl-metamask.css" }
        ],
        label: "Metamask Button",
        icon: "device_hub",
        componentName: "ctrl-metamask",
        type: "standard",
        acceptNodes: false,
        props: ["data", "properties", "guid"],
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align", "mapping", "mergeData"],
        defaults: {
            label: "Metamask Button",
            align: "left",
            full: false,
            right: false,
            mergeData: false,
            mapping: {},
            color: "primary",
            textColor: "white"
        }
    },
    exportcsv: {
        files: [
            { type: "js", path: "/components/export-csv/ctrl-export-csv.js" },
            { type: "html", path: "/components/export-csv/ctrl-export-csv.html" },
            { type: "css", path: "/components/export-csv/ctrl-export-csv.css" }
        ],
        label: "CSV Export",
        icon: "mdi-file-delimited",
        componentName: "ctrl-export-csv",
        type: "standard",
        acceptNodes: false,
        props: ["data", "properties", "guid"],
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align"],
        defaults: {
            label: "Export data",
            align: "left",
            full: false,
            right: false,
            color: "primary",
            textColor: "white"
        }
    },
    download: {
        files: [
            { type: "js", path: "/components/download/ctrl-download.js" },
            { type: "html", path: "/components/download/ctrl-download.html" },
            { type: "css", path: "/components/download/ctrl-download.css" }
        ],
        label: "Attachment download",
        icon: "mdi-file-download",
        componentName: "ctrl-download",
        type: "standard",
        get: true,
        acceptNodes: false,
        props: ["data", "properties", "guid"],
        dataModel: { attachment: true },
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align"],
        defaults: {
            label: "Download attachment",
            align: "left",
            full: false,
            right: false,
            color: "primary",
            textColor: "white"
        }
    },
    templates: {
        files: [
            { type: "js", path: "/components/templates/ctrl-templates.js" },
            { type: "html", path: "/components/templates/ctrl-templates.html" },
            { type: "css", path: "/components/templates/ctrl-templates.css" }
        ],
        label: "Generate document",
        icon: "mdi-file-document",
        componentName: "ctrl-templates",
        type: "standard",
        generator: true,
        set: true,
        acceptNodes: false,
        props: ["data", "properties", "guid"],
        events: ["onClick"],
        dataModel: { attachment: true },
        attributes: ["label", "icon", "color", "textColor", "right", "full", "align", "template", "format", "fileName", "hash", "hashMapping"],
        defaults: {
            label: "Generate document",
            align: "left",
            full: false,
            right: false,
            fileName: "export",
            hash: false,
            color: "primary",
            textColor: "white",
            format: "PDF"
        }
    },
    datetimepicker: {
        files: [
            { type: "js", path: "/components/datetimepicker/ctrl-datetimepicker.js" },
            { type: "html", path: "/components/datetimepicker/ctrl-datetimepicker.html" },
            { type: "css", path: "/components/datetimepicker/ctrl-datetimepicker.css" }
        ],
        label: "Date-time picker",
        icon: "mdi-calendar-clock",
        componentName: "ctrl-datetimepicker",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: ["data", "properties", "guid", "isMandatory", "mandatory", "readOnly", "path"],
        dataModel: { types: "type" },
        events: ["onInit", "onChange", "onBlur", "onSave", "onSubmit"],
        attributes: ["label", "icon", "iconColor", "helper", "type", "format", "canClear", "tHelper", "tHelperState"],
        defaults: {
            label: "New picker",
            type: "date",
            format: "DD-MM-YYYY",
            canClear: false,
            tHelper: false,
            tHelperState: false
        }
    },
    radio: {
        files: [
            { type: "js", path: "/components/radio/ctrl-radio.js" },
            { type: "html", path: "/components/radio/ctrl-radio.html" },
            { type: "css", path: "/components/radio/ctrl-radio.css" }
        ],
        label: "Options list",
        icon: "mdi-format-list-checks",
        componentName: "ctrl-radio",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: ["data", "properties", "guid", "isMandatory", "mandatory", "readOnly"],
        dataModel: { types: ["string"] },
        events: ["onInit", "onChange", "onSave", "onSubmit"],
        attributes: ["icon", "iconColor", "helper", "options", "inline", "leftLabel", "tHelper", "tHelperState"],
        defaults: {
            // eslint-disable-next-line max-len
            label: "Options",
            inline: false,
            leftLabel: false,
            tHelper: false,
            tHelperState: false,
            options: [
                { label: "Option one", value: "0" },
                { label: "Option two", value: "1" }
            ],
            type: "radio"
        }
    },
    checkbox: {
        files: [
            { type: "js", path: "/components/checkbox/ctrl-checkbox.js" },
            { type: "html", path: "/components/checkbox/ctrl-checkbox.html" },
            { type: "css", path: "/components/checkbox/ctrl-checkbox.css" }
        ],
        icon: "mdi-checkbox-marked-outline",
        componentName: "ctrl-checkbox",
        type: "form",
        get: true,
        set: true,
        acceptNodes: false,
        props: ["data", "properties", "guid", "isMandatory", "mandatory", "readOnly"],
        dataModel: { types: ["boolean"] },
        events: ["onInit", "onChange", "onClick", "onSave", "onSubmit"],
        attributes: ["icon", "iconColor", "helper", "leftLabel", "checkLabel", "indeterminate", "noIndeterminate", "tHelper", "tHelperState"],
        defaults: {
            checkLabel: "New checkbox",
            leftLabel: false,
            indeterminate: false,
            noIndeterminate: false,
            tHelper: false,
            tHelperState: false
        },
        fn: {
            checkMandatory(value, properties) {
                return properties.noIndeterminate ? value === true : value === true || value === false;
            },
            initValue(properties) {
                return properties.noIndeterminate ? false : null;
            }
        }
    },

    toggle: {
        files: [
            { type: "js", path: "/components/toggle/ctrl-toggle.js" },
            { type: "html", path: "/components/toggle/ctrl-toggle.html" },
            { type: "css", path: "/components/toggle/ctrl-toggle.css" }
        ],
        icon: "mdi-toggle-switch-outline",
        componentName: "ctrl-toggle",
        type: "form",
        get: true,
        set: true,
        nullValue: () => false,
        acceptNodes: false,
        props: ["data", "properties", "guid", "isMandatory", "mandatory", "readOnly"],
        dataModel: { types: ["boolean"] },
        events: ["onInit", "onChange", "onSave", "onSubmit"],
        attributes: ["label", "icon", "iconColor", "helper", "leftLabel", "toggleLabel", "tHelper", "tHelperState"],
        defaults: { toggleLabel: "New toggle", leftLabel: false, tHelper: false, tHelperState: false }
    },
    panel: {
        files: [
            { type: "js", path: "/components/panel/ctrl-panel.js" },
            { type: "html", path: "/components/panel/ctrl-panel.html" },
            { type: "css", path: "/components/panel/ctrl-panel.css" }
        ],
        icon: "mdi-application",
        componentName: "ctrl-panel",
        type: "layout",
        acceptNodes: true,
        props: ["data", "properties", "guid", "template", "newRender"],
        events: ["onInit"],
        attributes: ["label", "color", "textColor", "icon"],
        defaults: { label: "Panel", headerColor: "accent", titleColor: "tertiary" }
    },
    section: {
        files: [
            { type: "js", path: "/components/section/ctrl-section.js" },
            { type: "html", path: "/components/section/ctrl-section.html" },
            { type: "css", path: "/components/section/ctrl-section.css" }
        ],
        label: "Zone",
        icon: "mdi-select",
        componentName: "ctrl-section",
        type: "layout",
        padding: false,
        acceptNodes: true,
        props: ["data", "properties", "guid", "template"],
        attributes: ["label"],
        defaults: { label: "Zone" }
    },
    segment: {
        files: [
            { type: "js", path: "/components/segment/ctrl-segment.js" },
            { type: "html", path: "/components/segment/ctrl-segment.html" },
            { type: "css", path: "/components/segment/ctrl-segment.css" }
        ],
        namespace: true,
        get: true,
        set: true,
        icon: "mdi-table-plus",
        componentName: "ctrl-segment",
        type: "layout",
        acceptNodes: true,
        padding: false,
        props: ["data", "properties", "guid", "path", "template", "emptyBody", "readOnly", "idxFromList", "pathInsideList", "newRender"],
        events: ["onInit", "onChildInit", "onChange", "onChildChange", "onSave", "onSubmit"],
        attributes: ["label", "color", "textColor", "icon"],
        defaults: { label: "New segment", headerColor: "accent", titleColor: "tertiary", footerFirstColor: "primary", footerSecondColor: "white" }
    },
    segmentlist: {
        files: [
            { type: "js", path: "/components/segment-list/ctrl-segment-list.js" },
            { type: "html", path: "/components/segment-list/ctrl-segment-list.html" },
            { type: "css", path: "/components/segment-list/ctrl-segment-list.css" }
        ],
        label: "List",
        namespace: true,
        get: true,
        set: true,
        icon: "mdi-view-list",
        componentName: "ctrl-segment-list",
        type: "layout",
        acceptNodes: true,
        padding: false,
        props: ["data", "properties", "guid", "template", "emptyBody", "idxFromList", "readOnly", "newRender", "path"],
        events: ["onInit", "onChildInit", "onChange", "onChildChange", "onSave", "onSubmit"],
        attributes: ["label", "color", "textColor", "icon"],
        defaults: { label: "List", headerColor: "accent", titleColor: "tertiary", footerFirstColor: "primary", footerSecondColor: "white" }
    },
    select: {
        files: [
            { type: "js", path: "/components/select/ctrl-select.js" },
            { type: "html", path: "/components/select/ctrl-select.html" },
            { type: "css", path: "/components/select/ctrl-select.css" }
        ],
        label: "Drop-down list",
        componentName: "ctrl-select",
        icon: "mdi-chevron-down-box-outline",
        type: "form",
        get: true,
        set: true,
        values: true,
        acceptNodes: false,
        props: ["data", "properties", "events", "guid", "values", "isMandatory", "mandatory", "readOnly"],
        dataModel: { types: ["string"], catalogs: true },
        events: ["onInit", "onDisplayValue", "onChange", "onSave", "onSubmit"],
        attributes: ["label", "icon", "iconColor", "helper", "filter", "separator", "tHelper", "tHelperState"],
        defaults: {
            label: "New select",
            filter: false,
            separator: false,
            sort: "asc",
            tHelper: false,
            tHelperState: false
        }
    },
    autocomplete: {
        files: [
            { type: "js", path: "/components/autocomplete/ctrl-autocomplete.js" },
            { type: "html", path: "/components/autocomplete/ctrl-autocomplete.html" },
            { type: "css", path: "/components/autocomplete/ctrl-autocomplete.css" }
        ],
        componentName: "ctrl-autocomplete",
        icon: "mdi-textbox",
        type: "form",
        get: true,
        set: true,
        values: true,
        acceptNodes: false,
        props: ["data", "properties", "events", "guid", "values", "isMandatory", "mandatory", "readOnly"],
        dataModel: { types: ["string"], catalogs: true },
        events: ["onInit", "onDisplayValue", "onChange", "onSave", "onSubmit"],
        attributes: ["label", "icon", "iconColor", "helper", "tHelper", "tHelperState"],
        defaults: { label: "New autocomplete", tHelper: false, tHelperState: false }
    },
    mselect: {
        files: [
            { type: "js", path: "/components/mselect/ctrl-mselect.js" },
            { type: "html", path: "/components/mselect/ctrl-mselect.html" },
            { type: "css", path: "/components/mselect/ctrl-mselect.css" }
        ],
        label: "Drop-down list multiple",
        componentName: "ctrl-mselect",
        icon: "mdi-checkbox-multiple-marked",
        type: "form",
        get: true,
        set: true,
        values: true,
        nullValue: () => [],
        acceptNodes: false,
        props: ["data", "properties", "events", "guid", "values", "isMandatory", "mandatory", "readOnly"],
        dataModel: { list: true, catalogs: true },
        events: ["onInit", "onDisplayValue", "onChange", "onSave", "onSubmit"],
        attributes: ["label", "icon", "iconColor", "helper", "filter", "separator", "toggle", "chips", "tHelper", "tHelperState"],
        defaults: {
            label: "New select",
            filter: false,
            separator: false,
            chips: false,
            toggle: false,
            sort: "asc",
            tHelper: false,
            tHelperState: false
        },
        fn: {
            checkMandatory(value) {
                return value && value.length;
            }
        }
    },
    tabs: {
        files: [
            { type: "js", path: "/components/tabs/ctrl-tabs.js" },
            { type: "html", path: "/components/tabs/ctrl-tabs.html" },
            { type: "css", path: "/components/tabs/ctrl-tabs.css" }
        ],
        icon: "mdi-tab",
        componentName: "ctrl-tabs",
        type: "layout",
        events: ["onInit"],
        slots: true,
        slotClass: "q-tab",
        props: ["data", "properties", "guid", "slots", "idxFromList", "pathInsideList", "newRender"],
        slot: {
            defaults: { label: "New tab" }
        },
        attributes: ["label", "color", "textColor"],
        defaults: { label: "Tabs", headerColor: "accent", titleColor: "tertiary", normalTabBg: "accent", normalTabColor: "light" }
    },
    stepper: {
        files: [
            { type: "js", path: "/components/stepper/ctrl-stepper.js" },
            { type: "html", path: "/components/stepper/ctrl-stepper.html" },
            { type: "css", path: "/components/stepper/ctrl-stepper.css" }
        ],
        icon: "mdi-numeric",
        componentName: "ctrl-stepper",
        type: "layout",
        padding: false,
        props: ["data", "properties", "events", "guid", "slots", "idxFromList", "pathInsideList", "newRender"],
        events: ["onInit"],
        customEvents: ["onStepChange"],
        slots: true,
        slotClass: "step-item",
        slot: {
            defaults: { label: "New step" }
        },
        attributes: [
            // eslint-disable-next-line max-len
            "padding", "label", "headerColor", "titleColor", "activeHeaderColor", "passedHeaderColor", "activeTitleColor", "passedTitleColor", "labelPosition", "hasNavigation"
        ],
        defaults: {
            label: "Stepper",
            labelPosition: false,
            padding: 0,
            hasNavigation: false,
            headerColor: "light",
            titleColor: "accent",
            activeHeaderColor: "primary",
            activeTitleColor: "accent",
            passedHeaderColor: "secondary",
            passedTitleColor: "accent"
        }
    },
    collapsible: {
        files: [
            { type: "js", path: "/components/collapsible/ctrl-collapsible.js" },
            { type: "html", path: "/components/collapsible/ctrl-collapsible.html" },
            { type: "css", path: "/components/collapsible/ctrl-collapsible.css" }
        ],
        icon: "mdi-arrow-collapse-vertical",
        componentName: "ctrl-collapsible",
        type: "layout",
        events: ["onInit"],
        slots: true,
        slotClass: "q-item",
        props: ["data", "properties", "guid", "slots", "idxFromList", "pathInsideList", "newRender"],
        slot: {
            defaults: { label: "New collapsible" }
        },
        attributes: ["label", "backgroundColor", "fontColor", "fontSize", "fontFamily"],
        defaults: { label: "New collapsible" }
    },
    slot: {
        files: [
            { type: "js", path: "/components/slot/ctrl-slot.js" },
            { type: "html", path: "/components/slot/ctrl-slot.html" },
            { type: "css", path: "/components/slot/ctrl-slot.css" }
        ],
        icon: "mdi-tab-plus",
        componentName: "ctrl-slot",
        type: "hidden",
        acceptNodes: true,
        padding: false,
        props: ["guid"],
        attributes: ["label", "backgroundColor", "fontColor", "fontSize", "fontFamily"],
        defaults: { label: "Tab" }
    },
    fragment: {
        files: [
            { type: "js", path: "/components/fragment/ctrl-fragment.js" },
            { type: "html", path: "/components/fragment/ctrl-fragment.html" },
            { type: "css", path: "/components/fragment/ctrl-fragment.css" }
        ],
        label: "Fragment",
        icon: "mdi-puzzle",
        componentName: "ctrl-fragment",
        type: "hidden",
        padding: false,
        acceptNodes: false,
        props: ["data", "properties", "guid", "template"],
        attributes: ["readOnly"],
        defaults: { readOnly: false }
    },
    table: {
        files: [
            { type: "js", path: "/components/data-table/ctrl-data-table.js" },
            { type: "html", path: "/components/data-table/ctrl-data-table.html" },
            { type: "css", path: "/components/data-table/ctrl-data-table.css" }
        ],
        label: "Data table",
        icon: "mdi-table-large",
        componentName: "ctrl-data-table",
        type: "form",
        get: true,
        set: true,
        padding: false,
        dataModel: { list: true },
        acceptNodes: false,
        props: ["data", "properties", "events", "guid", "template", "path"],
        customEvents: ["onData", "onSelection"],
        attributes: [
            // eslint-disable-next-line max-len
            "label", "labelAlign", "headerColor", "labelColor", "icon", "columns", "height", "pagination", "exportCSV", "importXLS", "exportXLS", "clearData", "pageSize", "filterFormula", "rowAsToggle"
        ],
        defaults: {
            label: "",
            columns: [],
            height: "300px",
            pagination: false,
            exportCSV: false,
            exportXLS: false,
            rowAsToggle: false,
            importXLS: false,
            clearData: false,
            pageSize: 10,
            filterFormula: false,
            labelAlign: "left",
            multiSelect: false,
            headerBkColor: "accent",
            titleColor: "tertiary"
        }
    },
    takePicture: {
        files: [
            { type: "js", path: "/components/take-picture/ctrl-take-picture.js" },
            { type: "html", path: "/components/take-picture/ctrl-take-picture.html" },
            { type: "css", path: "/components/take-picture/ctrl-take-picture.css" }
        ],
        label: "Media capture",
        icon: "local_see",
        componentName: "ctrl-take-picture",
        type: "form",
        acceptNodes: false,
        get: true,
        set: true,
        dataModel: { attachment: true },
        events: ["onChange", "onSave", "onSubmit"],
        props: ["data", "path", "properties", "guid", "isMandatory", "mandatory", "readOnly"],
        attributes: [
            // eslint-disable-next-line max-len
            "label", "icon", "iconColor", "color", "textColor", "video", "photo", "captureName", "canDownload", "hash", "hashMapping", "timeVideo", "range", "tHelper", "tHelperState"
        ],
        defaults: {
            label: "Media Capture",
            video: false,
            captureName: "Media",
            photo: false,
            canDownload: false,
            hash: false,
            timeVideo: 10,
            tHelper: false,
            tHelperState: false
        }
    }
};

export { components };
